let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("4uhlL")]).then(() => parcelRequire('ior5s'));